import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { EditWorkspaceMenu } from './editWorkspaceMenu';

type Props = {
  workspaceIds: string[];
};

export const WorkspacesSelectionPanelMain = ({ workspaceIds }: Props) => {
  const { t } = useTranslation();

  // Edit targets a single workspace, so only surface the action with exactly
  // one selection.
  const workspaceId = workspaceIds.length === 1 ? workspaceIds[0] : undefined;

  return (
    <View style={styles.container}>
      {workspaceId && (
        <EditWorkspaceMenu
          workspaceId={workspaceId}
          label={t('workspace.menu.editWorkspace')}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 12,
  },
});
